import { useEffect, useState } from 'react';

export const useOpenGetQuote = () => {
  const [openGetQuoteIframe, setOpenGetQuoteIframe] = useState(false);

  useEffect(() => {
    const listener = (e: MessageEvent<string>) => {
      if (e.data === 'close-iframe') {
        setOpenGetQuoteIframe(false);
      }
    };

    if (window) window.addEventListener('message', listener);
    return () => {
      if (window) window.removeEventListener('message', listener);
    };
  });

  return {
    openGetQuoteIframe,
    setOpenGetQuoteIframe,
  };
};
